<template>
  <div class="notice" :style="{'paddingTop': statusBar + 'rem'}" ref="getheigh">
    <Headerd title="公告栏" :back="true" left="返回" :white="true" />
    <div class="noticemain" ref="getheight">
      <ul class="list">

        <li v-for="(item, i) in noticList" :key="i" @click="gotoNotice(item.noticeId)">
          <p class="redio">
            <span></span>
          </p>
          <p class="text">
            <span class="text1">{{item.noticeTitle}}</span>
            <span class="text2">{{item.publishtime}}</span>
          </p>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import Headerd from "@/components/Headerd";
export default {
  name: "notice",
  /**
   * 初始化数据
   */
  data() {
    return {
      noticList: [],
      backormoren: true,
      statusBar: 0,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getMobileNoticList();
    console.log(window.scrollY);
  },
  updated() {
    /**
     * 页面加载完毕后Y轴置在最顶端
     * bug出现形式未知
     */
    window.scroll(0, 0);
    console.log("nextTick " + window.scrollY);
  },

  /**
   * 方法
   */
  methods: {
    /**
     * 获取首页menu数据
     */
    getMobileNoticList() {
      //     this.noticList=[{"noticeId":"6","noticeTitle":"李克强:推广国际贸易\"单一窗口\" 实现通关一体化","noticeUrl":"xx","publishtime":"2019/02/15","endtime":"2022/02/15","publisher":"电子口岸数据中心","istop":"0","status":"1","creatTime":"2020-03-08 21:03:35","note":null,"noticeContent":null},{"noticeId":"8","noticeTitle":"图片测试","noticeUrl":"xx","publishtime":"2019/02/15","endtime":"2022/02/15","publisher":"电子口岸数据中心","istop":"0","status":"1","creatTime":"2020-03-08 21:03:35","note":null,"noticeContent":null},{"noticeId":"7","noticeTitle":"一致化贸易单证设计指南","noticeUrl":"xx","publishtime":"2019/02/15","endtime":"2022/02/15","publisher":"电子口岸数据中心","istop":"0","status":"1","creatTime":"2020-03-08 21:03:35","note":null,"noticeContent":null}];
      this.$http1
        .post("/zsdyckserver/app/notice/getNotices", {})
        .then((res) => {
          this.noticList = res.resultData;
        })
        .catch((err) => {
          if (err === 302) {
            window.console.log(err);
          }
        });
    },

    /**
     * 跳转小应用
     */
    gotoNotice(noticeId) {
      this.backormoren = false;

      this.$router.push({
        name: "noticeDetail1",
        query: {
          noticeId: `${noticeId}`,
        },
      });
      //     this.$router.push(val)
      // this.$tool.sessionData('#ffffff', 'true');
    },
  },
  // beforeDestroy() {
  //   if(this.backormoren){
  //     this.$tool.beforeDestroy(1);
  //   }
  // },
  components: {
    Headerd,
  },
};
</script>

<style scoped lang="scss">
.notice {
  width: 100%;
  background: #f7f8fa;
  .noticemain {
    overflow: auto;
    background: #fff;
    .list {
      padding-top: 12px;
      li {
        display: flex;
        margin: 0 12px;
        .redio {
          width: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 6px;
            height: 6px;
            display: block;
            background: #a0a5aa;
            border-radius: 50%;
          }
        }
        .text {
          flex: 1;
          display: flex;
          padding: 20px 0;
          border-bottom: 1px solid $lineColor;
          .text1 {
            font-size: 12px;
            line-height: 14px;
            display: block;
            color: $fontColor;
            width: 250px;
            white-space: nowrap; //强制不换行
            overflow: hidden; //自动隐藏文字
            text-overflow: ellipsis; //文字隐藏后添加省略号
            -o-text-overflow: ellipsis; //适用于opera浏览器
          }
          .text2 {
            text-align: right;
            width: 80px;
            color: #a0a5aa;
            line-height: 14px;
            display: block;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>

